import { YearSelectAutocomplete } from './YearSelectAutocomplete';

export default YearSelectAutocomplete;
